import { render } from "./SkillSection.vue?vue&type=template&id=5ff72258"
import script from "./SkillSection.vue?vue&type=script&lang=js"
export * from "./SkillSection.vue?vue&type=script&lang=js"

import exportComponent from "/home/aungkhantkoko/Desktop/PortFolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__